import { jsx as _jsx } from "react/jsx-runtime";
import { Auth0Provider, } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
export const Auth0ProviderWithNavigate = (props) => {
    const navigate = useNavigate();
    const domain = process.env.AUTH0_DOMAIN;
    const clientId = process.env.AUTH0_CLIENT_ID;
    const audience = process.env.AUTH0_AUDIENCE;
    const redirectUri = `${location.protocol}//${location.host}/callback`;
    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || '/');
    };
    if (!(domain && clientId && redirectUri)) {
        return null;
    }
    return (_jsx(Auth0Provider, { domain: domain, clientId: clientId, authorizationParams: {
            audience: audience,
            redirect_uri: redirectUri,
        }, cacheLocation: "localstorage", onRedirectCallback: onRedirectCallback, children: props.children }));
};
